module.exports = __webpack_public_path__ + "img/Группа 6.20081537.png";